import CircleIcon from "@mui/icons-material/Circle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from "@mui/material";

export function VideoList({
  entries,
  courseName,
  topicName,
  expanded,
  handleChangeAccordion,
  currentVideo,
  handleChangeVideos,
}) {
  if (!entries?.length) return null;

  return (
    <Box borderBottom={0.5} borderColor="#eee">
      <Accordion
        sx={{ padding: 0, boxShadow: "none" }}
        expanded={expanded === courseName}
        onChange={handleChangeAccordion(courseName)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel-content-${courseName}`}
          id={`panel-header-${courseName}`}
          color={
            courseName === currentVideo?.course ? "primary.main" : "inherit"
          }
        >
          <OndemandVideoIcon sx={{ mr: 2 }} />
          {courseName}
        </AccordionSummary>
        <AccordionDetails>
          {entries.map((video, idx) => (
            <Button
              key={video.id || idx}
              color={video.id === currentVideo?.id ? "primary" : "inherit"}
              display="flex"
              alignItems="flex-start"
              onClick={() =>
                handleChangeVideos({
                  position: idx,
                  topico: topicName,
                  course: courseName,
                  ...video,
                })
              }
              fullWidth
              sx={{ justifyContent: "flex-start" }}
            >
              <CircleIcon sx={{ height: 5 }} />
              <Typography
                fontSize={14}
                align="left"
                ml={2}
                sx={{ overflowWrap: "anywhere" }}
              >
                {video?.title}
              </Typography>
            </Button>
          ))}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
